/** @format */

import { useEffect, useState, createContext } from 'react';
import MainRoutes from './routes';
import './styles/main.css';
import { addGuestDetails, recordUserVisit } from './services/home.service';

const AppContext = createContext();
function App() {
  const [viewportHeight] = useState(
    window.innerWidth > 768 ? window.innerHeight : window.outerHeight
  );
  const [headerHeight, setHeaderHeight] = useState(0);
  const [uuid, setUUID] = useState(localStorage.getItem('uuid'));

  function handleUUID() {
    if (!uuid) {
      // create based on date.
      const newUUID = Date.now();
      localStorage.setItem('uuid', newUUID);
      setUUID(newUUID);

      // catch url param, look for 'ref'
      const params = new URLSearchParams(document.location.search);
      const name = params.get('ref') || 'absent';

      recordUserVisit({ uuid: newUUID, ref: name }).then(() => {});
      return newUUID;
    }
  }

  function handleLocation() {
    navigator.geolocation.getCurrentPosition(success, error);
    function success(succ) {
      const {
        coords: { latitude, longitude },
      } = succ;

      addGuestDetails({ uuid: uuid, location: { latitude, longitude } });
    }
    function error(err) {
      console.log(err);
    }
  }

  useEffect(() => {
    handleUUID();
  }, []);

  useEffect(() => {
    if (uuid) {
      handleLocation();
    }
  }, [uuid]);

  const ctxValue = {
    headerHeight,
    viewportHeight,
    setHeaderHeight,
    handleUUID,
    uuid,
  };

  return (
    <AppContext.Provider value={ctxValue}>
      <MainRoutes />
    </AppContext.Provider>
  );
}

export default App;
export { AppContext };
